import { addTask } from '../../utilities/ssr-task';
import APIManager from '../../utilities/api-manager';
import {
    API_CLEAR_COLLECTIONS,
    API_CLEAR_COLLECTIONS_ERROR,
    API_CREATE_COLLECTION,
    API_CREATE_COLLECTION_FAILED,
    API_FETCH_COLLECTIONS,
    API_DELETE_COLLECTION,
    API_UPDATE_COLLECTION,
    API_UPDATE_COLLECTION_FAILED,
    API_SAVE_TILE_COLLECTIONS_FAILED,
    API_SAVE_TILE_COLLECTIONS,
    API_COPY_COLLECTION_FAILED,
    API_COPY_COLLECTION
} from '../actionTypes';

const createCollection = (payload: CreateCollectionItem, onSuccess?: () => void, onError?: () => void): AppThunkAction<CreateCollectionAction> => dispatch => {
    const createTask = APIManager.createCollection(payload).then(response => {
        if (response && response.status === 400) {
            dispatch({ response: response.data, type: API_CREATE_COLLECTION_FAILED });
            if (onError) {
                onError();
            }
            return;
        }
        dispatch({ response: response.data, type: API_CREATE_COLLECTION });
        if (onSuccess) {
            onSuccess();
        }
    });
    addTask(createTask);
};

const updateCollection = (payload: CreateCollectionItem, onSuccess?: () => void, onError?: (message: string) => void): AppThunkAction<UpdateCollectionAction> => dispatch => {
    const updateTask = APIManager.createCollection(payload).then(response => {
        if (response && response.status === 400) {
            const errorMessage = (response.data && (response.data as any).message) || 'An error occurred.';
            dispatch({ response: response.data, type: API_UPDATE_COLLECTION_FAILED });
            if (onError) {
                onError(errorMessage as string);
            }
            return;
        }
        dispatch({ response: { ...response.data, collectionId: payload.collectionId }, type: API_UPDATE_COLLECTION });
        if (onSuccess) {
            onSuccess();
        }
    });
    addTask(updateTask);
};

const copyCollection = (payload: CopyCollectionItem, onSuccess?: () => void, onError?: (message: string) => void): AppThunkAction<CopyCollectionAction> => dispatch => {
    const updateTask = APIManager.copyCollection(payload).then(response => {
        if (response && response.status === 400) {
            const errorMessage = (response.data && (response.data as any).message) || 'An error occurred.';
            dispatch({ response: response.data, type: API_COPY_COLLECTION_FAILED });
            if (onError) {
                onError(errorMessage as string);
            }
            return;
        }
        dispatch({ response: { ...response.data }, type: API_COPY_COLLECTION });
        if (onSuccess) {
            onSuccess();
        }
    });
    addTask(updateTask);
};

const deleteCollection = (payload: DeleteCollectionItem): AppThunkAction<DeleteCollectionAction> => dispatch => {
    const deleteTask = APIManager.deleteCollection(payload).then(response => {
        dispatch({
            response: {
                ...response.data,
                collectionId: payload.collectionId
            },
            type: API_DELETE_COLLECTION
        });
    });
    addTask(deleteTask);
};

const fetchCollections = (): AppThunkAction<FetchCollectionsAction> => dispatch => {
    const fetchTask = APIManager.fetchCollections().then(response => {
        dispatch({ response: response.data, type: API_FETCH_COLLECTIONS });
    });
    addTask(fetchTask);
};

export const clearCollections = (): AppThunkAction<ClearCollectionsAction> => dispatch => {
    dispatch({ response: [], type: API_CLEAR_COLLECTIONS });
};

export const clearCollectionsError = (): AppThunkAction<ClearCollectionsErrorAction> => dispatch => {
    dispatch({ response: [], type: API_CLEAR_COLLECTIONS_ERROR });
};

const saveTileCollections = (payload: UpdateTileCollection, onSuccess?: () => void): AppThunkAction<SaveTileCollectionsAction> => dispatch => {
    const saveTask = APIManager.saveTileCollections(payload).then(response => {
        if (response && response.status === 400) {
            dispatch({ response: response.data, type: API_SAVE_TILE_COLLECTIONS_FAILED });
            return;
        }
        dispatch({ response: { payload }, type: API_SAVE_TILE_COLLECTIONS });
        if (onSuccess) {
            onSuccess();
        }
    });
    addTask(saveTask);
};

export { createCollection, updateCollection, fetchCollections, saveTileCollections, deleteCollection, copyCollection };
